__turbopack_context__.v({
  "loading": "reviews-module-scss-module__CaNvQa__loading",
  "no-reviews-message": "reviews-module-scss-module__CaNvQa__no-reviews-message",
  "review": "reviews-module-scss-module__CaNvQa__review",
  "reviews-desktop": "reviews-module-scss-module__CaNvQa__reviews-desktop",
  "reviews-title": "reviews-module-scss-module__CaNvQa__reviews-title",
  "trigger-button-container": "reviews-module-scss-module__CaNvQa__trigger-button-container",
});
